import { render, staticRenderFns } from "./FormsOverview.vue?vue&type=template&id=5ad0bc17&scoped=true&"
import script from "./FormsOverview.vue?vue&type=script&lang=js&"
export * from "./FormsOverview.vue?vue&type=script&lang=js&"
import style0 from "./FormsOverview.vue?vue&type=style&index=0&id=5ad0bc17&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad0bc17",
  null
  
)

export default component.exports